const MuiSlider = {
  color: 'secondary'
};
export default MuiSlider;